import get from 'lodash/get';

export const subscriptionTypesInput = {
  state: 'STATE',
  county: 'COUNTY',
  zip: 'ZIP_CODE',
  sector: 'SECTOR',
};

export const diversityOptions = [
  { text: 'All Students', value: 'ALL_STUDENTS' },
  { text: 'Female', value: 'FEMALE_STUDENTS' },
  { text: 'Male', value: 'MALE_STUDENTS' },
  { text: 'Racial & Ethnic Minority', value: 'RACIAL_AND_ETHNIC_MINORITY' },
  { text: 'Schools with High FRL Rate', value: 'SCHOOLS_WITH_HIGH_FRL_RATE' },
];

export const getLocation = (displaySubscription) => {
  const { type, zipCode, state, county, sector } = displaySubscription;
  let location = '';
  /* istanbul ignore else */
  if (type === subscriptionTypesInput.zip && zipCode && zipCode.zipCode) {
    location = zipCode.zipCode + (
      (zipCode.radius && zipCode.radius > 0) ? ` - Within ${zipCode.radius} Miles` : ''
    );
  } else if (type === subscriptionTypesInput.state && state) {
    location = state;
  } else if (type === subscriptionTypesInput.county && typeof county === 'object') {
    location = (county) ? `${county.state} - ${county.county} County` : '';
  } else if (type === subscriptionTypesInput.sector && sector) {
    location = sector;
  }
  return location;
};

export const getDiversity = (displaySubscription) => {
  const { diversity } = displaySubscription;
  const diversityOption = diversityOptions.find(({ value }) => value === diversity);
  return get(diversityOption, 'text', '');
};

export const getCompetitors = (displaySubscription) => {
  const { competitors } = displaySubscription;
  let competitorsDisplay = '';
  if (Array.isArray(competitors)) {
    competitorsDisplay = competitors.map((item) => item.name).join(', ');
  }
  return competitorsDisplay;
};

const buildDisplaySubscription = (propSubscription) => {
  const {
    id,
    type,
    majors,
    connection,
    academicThreshold: {
      enabled,
    },
    startDate,
    endDate,
    audience: {
      zipCode,
      state,
      county,
      sector,
      diversity,
    },
    messages,
    lastModifiedDate,
    lastModifiedBy,
  } = propSubscription;

  const subscription = {
    id,
    type,
    majors,
    connection,
    startDate,
    endDate,
    lastModifiedDate,
    lastModifiedBy,
  };

  if (type === subscriptionTypesInput.zip && typeof zipCode === 'object') {
    subscription.zipCode = zipCode;
  } else if (type === subscriptionTypesInput.sector) {
    subscription.sector = sector;
  } else {
    /* istanbul ignore else */
    if (type === subscriptionTypesInput.state && state) {
      subscription.state = state;
    }

    /* istanbul ignore else */
    if (type === subscriptionTypesInput.county && typeof county === 'object') {
      subscription.county = county;
    }
  }

  /* istanbul ignore else */
  if (messages && Array.isArray(messages.competitors)) {
    subscription.competitors = messages.competitors.map(({ scid, name }) => ({ id: scid, name }));
  }

  subscription.diversity = (diversity) || diversityOptions[0].value;

  subscription.academicThreshold = enabled;

  return subscription;
};

export default buildDisplaySubscription;
